import { ComponentIds, ProductUtils } from '@inter-ikea-core/core';
import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
/**
 * Valet Hanger needs to use special connectors for attaching on 58cm deep corner frame since the corner frame only have holes tagged with DEPTH 350.
 */
export class ValetHangerOnCornerAddonFrameValidationRule extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'ValetHangerOnCornerAddonFrameValidationRule');
        this.CORNER_FRAME_CONNECTOR_RIGHT_580 = 'right-corner-580';
        this.CORNER_FRAME_CONNECTOR_LEFT_580 = 'left-corner-580';
        this.coreApi = coreApi;
    }
    validateCurrentState(entity) {
        return this.validate(entity);
    }
    validateSnap(snapActionCandidate) {
        return this.validate(snapActionCandidate.guestRoot, snapActionCandidate);
    }
    validate(entity, snapActionCandidate) {
        if (!this.coreApi.entities.isProductType(entity, ProductType.PAX_VALET_HANGER))
            return this.validationOK();
        if (!snapActionCandidate?.host)
            return this.validationOK();
        const host = snapActionCandidate?.host;
        const connectorKey = snapActionCandidate.guestConnector.key;
        const isCornerConnector = connectorKey === this.CORNER_FRAME_CONNECTOR_RIGHT_580 ||
            connectorKey === this.CORNER_FRAME_CONNECTOR_LEFT_580;
        const is58DeepCornerFrame = this.coreApi.entities.isProductType(host, ProductType.PAX_ADD_ON_CORNER_FRAME) &&
            this.getComSizeDepth(host) == 580.0;
        if (is58DeepCornerFrame) {
            if (isCornerConnector) {
                return this.validationOK();
            }
            else {
                return this.validationFail('');
            }
        }
        else if (isCornerConnector) {
            return this.validationFail('');
        }
        else {
            return this.validationOK();
        }
    }
    getComSizeDepth(entity) {
        const comSize = entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID);
        if (comSize == null) {
            /* eslint-disable-next-line no-console */
            console.warn(`Entity ${entity.id} with product ${ProductUtils.productRef(entity)} has no CommunicationSizeComponent. ValetHangerOnCornerAddonFrameValidationRule needs to know the size of the entity`);
        }
        return comSize?.size?.depth ?? 0.0;
    }
}
//# sourceMappingURL=ValetHangerOnCornerAddonFrameValidationRule.js.map